(ns dre.modals.annotator.views
  (:require
   [dre.components.inputs :refer [checkbox]]
   [dre.components.form :refer [form form-item]]
   [dre.i18n.views :refer [tr]]
   [dre.modals.annotator.events :as modal-annotator-events]
   [dre.pages.annotator.events :as events]
   [dre.modals.modal-window :refer [modal-window]] 
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn content
  [skip-pico? use-excerpt-mode?]
  [:div 
   [form 
    {:layout "vertical"}
    [:<>
     [form-item
      {}
      [checkbox
       {:checked @use-excerpt-mode?
        :on-change #(reset! use-excerpt-mode? (not @use-excerpt-mode?))}
       [tr "Use excerpt (bindings) mode"]]]
     [form-item
      {}
      [checkbox
       {:checked @skip-pico?
        :on-change #(reset! skip-pico? (not @skip-pico?))}
       [tr "Skip PICO classification"]]]]]])

(defn view
  []
  (let [current-settings @(rf/subscribe [::events/get-settings])
        skip-pico? (r/atom (:skip-classification current-settings))
        use-excerpt-mode? (r/atom (:mode/unbound-mode? current-settings))]
    (fn []
      [modal-window
       {:title "Annotator Settings"
        :content (partial content skip-pico? use-excerpt-mode?)
        :submit? true
        :submit-text [tr "Done"]
        :submit-disabled? false
        :on-submit (fn [e]
                     (rf/dispatch [::modal-annotator-events/clear])
                     (rf/dispatch [::events/update-settings @skip-pico? @use-excerpt-mode?]))}])))